import { servicesResources } from "../Resources/Services";
import { getLang } from "../lib";
import FadeInOnScroll from "./FadeInOnScroll";
import { ROUTES, getRoutePath } from "../Resources/routes";
import { dropdownIds } from "../Resources/SharedResources";

function Services() {
    const lang = getLang();
    document.title = servicesResources[lang].Title;

    const serviceList = [
        {
            id: dropdownIds.services.BPO,
            data: servicesResources[lang].BPO,
            img: "/images/financialBPO.jpeg",
            ctaType: "primary",
        },
        {
            id: dropdownIds.services.FPA,
            data: servicesResources[lang].FPA,
            img: "/images/fpa.jpg",
            ctaType: "secondary",
        },
        {
            id: dropdownIds.services.CFO,
            data: servicesResources[lang].CFO,
            img: "/images/fractional-cfo.jpg",
            ctaType: "primary",
        },
    ];

    return (
        <div className="services-page">
            <section className="services">
                <FadeInOnScroll delay={0.2}>
                    <h1>{servicesResources[lang].Title}</h1>
                    <p>{servicesResources[lang].Intro}</p>
                </FadeInOnScroll>
            </section>

            {serviceList.map((service, index) => (
                <div
                    key={service.id}
                    id={service.id}
                    className={`page-item ${index % 2 === 1 ? "reverse" : ""} ${index === 2 ? "mb-50" : ""}`}
                >
                    <FadeInOnScroll delay={0.3}>
                        <section className="txt-holder child-item">
                            <h1>{service.data.Title}</h1>
                            <p>{service.data.Overview}</p>

                            <h3>{servicesResources[lang].Includes}</h3>
                            <ul>
                                {service.data.Services.map((item, i) => (
                                    <li key={i}>{item}</li>
                                ))}
                            </ul>

                            <h3>{servicesResources[lang].Outcomes}</h3>
                            <ul>
                                {service.data.Outcomes.map((item, i) => (
                                    <li key={i}>{item}</li>
                                ))}
                            </ul>

                            <a
                                href={getRoutePath(ROUTES.CONTACT, lang)}
                                className={service.ctaType === "primary" ? "primaryCTA-btn" : "secondaryCTA-btn"}
                            >
                                {service.data.CTA.trim()}
                            </a>
                        </section>
                    </FadeInOnScroll>

                    <FadeInOnScroll delay={0.4}>
                        <div className="img-holder child-item">
                            <img src={service.img} alt={service.data.Title} />
                        </div>
                    </FadeInOnScroll>
                </div>
            ))}
        </div>
    );
}

export default Services;
